<template>
    <div >
        <div v-if="viewFooter"  class="container d-flex justify-content-center" :class="{'vueIsCool':inDisplay, 'animate-height':heightZero}" :style="{ backgroundImage: 'url(' + require('@/assets/img/background-up.jpg') + ')' }">
            <div class="vueIsCool vueLogo" >
                <img src="img/VUE.gif" alt="" :class="{'animate':setOFF}" />
            </div>        
            <div class="vueIsCool title" :class="{'animate':setOFF}">VUE JS 3</div>
            <div class="vueIsCool subtitle" :class="{'animate':setOFF}">{{isCool}}</div>
        </div>

        <!---
        <div class="container d-flex justify-content-center" :class="{'vueIsCool':inDisplay, 'animate-height':heightZero}" :style="{ backgroundImage: 'url(' + require('@/assets/img/background-up.jpg') + ')' }">
            <div class="vueIsCool vueLogo" :class="{'animate':setOFF}">
                <img src="img/VUE.gif" alt="">
            </div>
            <div class="vueIsCool title" :class="{'animate':setOFF}">VUE JS 3</div>
            <div class="vueIsCool subtitle" :class="{'animate':setOFF}">Is Cool !</div>
            < !---{{isCool}}-- >
        </div>
        -->

        <div class="container bgColorMain " >
            <div v-if="!viewFooter" class="eIDSignum">
                <span class="eIDSignum1">{{$t("eIDSignum.1")}} </span>
                <span> </span>
                <a target="parent"  href="https://zep.disig.sk/Portal"><span class="eIDSignumLink">https://zep.disig.sk/Portal</span></a>.
                <br />
                <span class="eIDSignum2">{{$t("eIDSignum.2")}}</span>.
            </div>



            <div class="row">

                <curr-photo />

                <concat-info />
            </div>
            
            <div class="row">
                <div style="" class="col-md-4 otherInfoLeft1  bgColorLeft ">

                    <other-info />

                    <education-info />

                    <knowledge-info />                

                    <lang-info />

                    <hobbies-info />

                </div>
                
                <div style="" class="col-md-8  otherInfoRight1 ">
                    <experiences-info />
                </div>    
            </div>

            <end-info />

        </div>

        <footer-icons v-if="viewFooter" />
       
    </div>
</template>

<script>
    import CurrPhoto from "@/components/CurrPhoto.vue"
    import ConcatInfo from "@/components/ConcatInfo.vue"
    import OtherInfo from "@/components/OtherInfo.vue"
    import EducationInfo from "@/components/EducationInfo.vue"
    import KnowledgeInfo from "@/components/KnowledgeInfo.vue"
    import LangInfo from "@/components/LangInfo.vue"
    import HobbiesInfo from "@/components/HobbiesInfo.vue"
    import ExperiencesInfo from "@/components/ExperiencesInfo.vue"
    import EndInfo from "@/components/EndInfo.vue"
    import FooterIcons from "@/components/FooterIcons.vue"

    export default {
        components: {
            CurrPhoto,
            ConcatInfo,
            OtherInfo,
            EducationInfo,
            KnowledgeInfo,
            LangInfo,
            HobbiesInfo,
            ExperiencesInfo,
            EndInfo,
            FooterIcons
        },
        data() {
            return {
                setOFF:false,
                heightZero:false,
                inDisplay: true,
                viewFooter: true,
                isCool:""
            }
        },
        methods: {
            isCoolAnimate() {
                let timeOut = 1000
                let delay = 400
                setTimeout(() => {this.isCool = this.isCool + "I" }, timeOut);
                timeOut += delay
                setTimeout(() => {this.isCool = this.isCool + "s" }, timeOut);
                setTimeout(() => {this.isCool = this.isCool + " " }, timeOut);
                timeOut += delay
                setTimeout(() => {this.isCool = this.isCool + "C" }, timeOut);
                timeOut += delay
                setTimeout(() => {this.isCool = this.isCool + "o" }, timeOut);
                timeOut += delay
                setTimeout(() => {this.isCool = this.isCool + "o" }, timeOut);
                timeOut += delay
                setTimeout(() => {this.isCool = this.isCool + "l" }, timeOut);
                timeOut += delay
                setTimeout(() => {this.isCool = this.isCool + " " }, timeOut);
                setTimeout(() => {this.isCool = this.isCool + "!" }, timeOut);
                timeOut += delay
                setTimeout(() => {this.setOFF = true }, timeOut);
                timeOut+=2000
                setTimeout(() => {this.heightZero = true; }, timeOut);
                timeOut+=5000
                setTimeout(() => {this.inDisplay = false;}, timeOut);
            },
            getValueFromURL(param)   {
    
                let returnValue = ""
                let path = window.location.href
                let aPath = path.toString().split('?')    
                let aParam

                if(Object.keys(aPath).length > 1) {
                    let aMembers = aPath[1].split('&') 
                    for(let key in aMembers) {
                        aParam = aMembers[key].split("=")        
                        if(param.trim().toLowerCase()==aParam[0].trim().toLowerCase()) {
                            returnValue = aParam[1]
                            break
                        }
                    }
                }

                return returnValue
            }

        },
        mounted () {
            window.scrollTo(0,0)
            this.isCoolAnimate()
            if(this.getValueFromURL('lang') == "en") this.$i18n.locale = 'en'
            //alert(window.innerWidth)

        },
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/styles/cascade.scss";
    @import "@/assets/styles/dataTitle.scss";
    @import "@/assets/styles/footer.scss";
</style>

<style lang="scss" scoped>

.vueIsCool {
    margin-left: auto;
    margin-right: auto;
    width:100%;
    height:250px;
}

.vueLogo {
    position:absolute;
    top:25px;
    animation: LogoIn 10s;
}

@keyframes LogoIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

.title {
    position:absolute;
    top:85px;
    color:#3fb27f;
    font-size: 4em;
    font-weight: 700;
    animation: TitleIn 3s;
}

@keyframes TitleIn {
  0% {top:-50px;}
  100% {top:80px;}
}

.subtitle {
    position:absolute;
    color:#fa4e4e;
    font-size: 2.5em;
    font-weight: 700;
    top:180px;
}    

/*
.vueIsCool {
    margin-left: auto;
    margin-right: auto;
    width:100%;
    height:250px;
    & .title {
        width:50%;
        height:80px;
        color:#3fb27f;
        padding-top:0px;
        z-index: 500;
        border:solid 1px red;
        font-size: 4em;
        font-weight: 700;
    }
    & .subtitle {
        width:50%;
        height:40px;
        color:#fa4e4e;
        padding-top:10px;
        z-index: 300;
        border:solid 1px red;
        font-size: 2.5em;
        font-weight: 700;
    }    
    &.vueLogo {
        border:solid 1px red;
        padding-top:20px;
    }    
}


*/

.animate {
    //height:0px;
    animation: fadeIn 5s;

}

@keyframes fadeIn {
  0% {opacity:1;}
  100% {opacity:0;}
}

.animate-height {
    animation: heightIn 5s;
    //height:0px;
}

@keyframes heightIn {
  0% {height:250;}
  100% {height:0px;}
}

</style>